import {
    LOAD_CATALOG_SUCCESS,
    LOAD_DOCUMENT_SUCCESS,
    BASE64_REMOVE,
    CONTACTO_ADD,
    INCREASE_SIGUIENTE,
    ESTADO_AFILIACION_COMPANY,
    SAVED_CATALOG_COMPANY,
    NUMBER_FORMULARIO_FIREBASE,
    IDUSER_FORMULARIO_FIREBASE,
    MODAL_INFORMACION_FLUJOS,
    SAVE_ANEXOS,
    POPUP_SEE_ANEXOS,
    OPEN_MODAL_NUM_PROCESS,
    SAVE_DATA_TABLE_PERSONAL,
    OPEN_MODAL_CHARGED,
    SAVE_REFE_FILES,
    DATA_PANTALLA_INICIO,
    FORMULARIO_TYPE,
    CALL_DINAMIC_DISABLE,
    CALL_DINAMIC_DISABLE_LOTE,
    CHARGE_ANEXOS_STORAGE,
    SAVED_EMPLEADOR_TYPE,
    LIMITE_STEP,
    OPEN_FINAL_MODAL,
    CLOSE_MODAL_FINAL,
    SAVED_SOLICITUDES,
    OPEN_MODAL_FINAL_FORM,
    SAVE_REFERENCE_BARCODE,
    CLEAN_AUTO_COMPLETE,
    CHANGE_CORREGIMIENTO_FORM,
    OPEN_MODAL_FORMULARIO_REG,
    DEVUELTA_MODIFICACION_ACTIVE,
    SAVED_TAMANIO_FILES,
    SAVED_ID_APP,
    UPLOAD_ANEXOS_FROM_SAGA,
    SAVE_USER_COMERCIAL,
    CHANGES_FROM_BANDEJA,
    SAVE_PERSONAL_ADMIN,
    OPEN_MODAL_ACCEPT_PDF,
    VER_MOTIVO_DEVOLUCION,
    CREATE_USUARIO_PERSONA,
    SAVE_ANEXOS_FROM_DEVOL,
    SAVE_SOLICITUDES_SIN_FIRMA,
    ERROR_GENERAL,
    UPDATE_MSG_SOLICITUD,
    EDITING_ENABLED_CONTACT,
    VALID_RNEC_REP_LEGAL,
    INIT_EDITAR_FROM_BANDEJA,
    SAVE_DATOS_CEDULAS_RNEC,
    CHANGE_COMPONENT_ID,
    DELETE_CONTACTO_FROM_VALID_STEP4,
    ACTIVATE_SOPORT_RNEC,
    CLOSE_DIRECCION_MODAL_SUCCESS,
    SAVE_MAPEO_RUES_SUCCESS,
    
} from './constants'

export function loadCatalogSuccess (payload) {
    return {
        type: LOAD_CATALOG_SUCCESS,
        payload
    };
}

export function loadDocumentSuccess (payload) {
    return {
        type: LOAD_DOCUMENT_SUCCESS,
        payload
    };
}

export function base64Remove(payload) {
    return {
        type: BASE64_REMOVE,
        payload
    };
}
export function contactoAdd (payload) {
    return {
        type: CONTACTO_ADD,
        payload
    };
}

export function increaseSiguiente (payload) {
    return {
        type: INCREASE_SIGUIENTE,
        payload
    };
}

//_________________________
export function estadoAfiliacionCompany (payload) {
    return {
        type: ESTADO_AFILIACION_COMPANY,
        payload
    };
}

export function savedCatalogCompany (payload) {
    return {
        type: SAVED_CATALOG_COMPANY,
        payload
    };
}

export function saveIdFormulario (payload) {
    return {
        type: NUMBER_FORMULARIO_FIREBASE,
        payload
    };
}

export function saveIdUser(payload) {
    return {
        type: IDUSER_FORMULARIO_FIREBASE,
        payload
    };
}

export function modalInformacionFlujos(payload) {
    return {
        type: MODAL_INFORMACION_FLUJOS,
        payload
    };
}

export function saveAnexos(payload) {
    return {
        type: SAVE_ANEXOS,
        payload
    };
}

export function saveMapeoRuesSuccess(payload) {
    return {
        type: SAVE_MAPEO_RUES_SUCCESS,
        payload
    };
}

export function errorGeneral(payload) {
    return {
        type: ERROR_GENERAL,
        payload
    };
}

export function saveAnexosFromDevol(payload) {
    return {
        type: SAVE_ANEXOS_FROM_DEVOL,
        payload
    };
}

export function chargeAnexosStorage(payload) {
    return {
        type: CHARGE_ANEXOS_STORAGE,
        payload
    };
}

export function popupSEEAnexos(payload) {
    return {
        type: POPUP_SEE_ANEXOS,
        payload
    };
}

export function openModalNumProcess(payload) {
    return {
        type: OPEN_MODAL_NUM_PROCESS,
        payload
    };
}

export function saveDataTablePersonal(payload) {
    return {
        type: SAVE_DATA_TABLE_PERSONAL,
        payload
    };
}

export function openModalCharged(payload) {
    return {
        type: OPEN_MODAL_CHARGED,
        payload
    };
}

export function saveRefeFiles(payload) {
    return {
        type: SAVE_REFE_FILES,
        payload
    };
}

export function changeComponentId(payload) {
    return {
        type: CHANGE_COMPONENT_ID,
        payload
    };
}

export function dataPantallaInicio(payload) {
    return {
        type: DATA_PANTALLA_INICIO,
        payload
    };
}

export function editingEnabledContact(payload) {
    return {
        type: EDITING_ENABLED_CONTACT,
        payload
    };
}

export function activateSoportRnec(payload) {
    return {
        type: ACTIVATE_SOPORT_RNEC,
        payload
    };
}

export function initEditarFromBandeja(payload) {
    return {
        type: INIT_EDITAR_FROM_BANDEJA,
        payload
    };
}

export function saveDatosCedulasRnec(payload) {
    return {
        type: SAVE_DATOS_CEDULAS_RNEC,
        payload
    };
}

export function validRnecRepLegal(payload) {
    return {
        type: VALID_RNEC_REP_LEGAL,
        payload
    };
}

export function deleteContactsFromValidationStep4(payload) {
    return {
        type: DELETE_CONTACTO_FROM_VALID_STEP4,
        payload
    };
}

export function formularioType(payload) {
    return {
        type: FORMULARIO_TYPE,
        payload
    };
}

export function callDinamicDisable(payload) {
    return {
        type: CALL_DINAMIC_DISABLE,
        payload
    };
}

export function callDinamicDisableLote(payload) {
    return {
        type: CALL_DINAMIC_DISABLE_LOTE,
        payload
    };
}

export function savedEmpleadorType(payload) {
    return {
        type: SAVED_EMPLEADOR_TYPE,
        payload
    };
}

export function limitStep(payload) {
    return {
        type: LIMITE_STEP,
        payload
    };
}

export function closeFinalModal(payload) {
    return {
        type: CLOSE_MODAL_FINAL,
        payload
    };
}

export function savedSolicitudes(payload) {
    return {
        type: SAVED_SOLICITUDES,
        payload
    };
}

export function openFinalModal(payload) {
    return {
        type: OPEN_MODAL_FINAL_FORM,
        payload
    };
}

export function savePersonalAdmin(payload) {
    return {
        type: SAVE_PERSONAL_ADMIN,
        payload
    };
}

export function openModalAcceptPDF(payload) {
    return {
        type: OPEN_MODAL_ACCEPT_PDF,
        payload
    };
}

export function saveReferenceBarcode(payload) {
    return {
        type: SAVE_REFERENCE_BARCODE,
        payload
    };
}

export function cleanAutoComplete(payload) {
    return {
        type: CLEAN_AUTO_COMPLETE,
        payload
    };
}

export function openModalTerminos(payload) {
    return {
        type: OPEN_FINAL_MODAL,
        payload
    };
}

export function changeCorregimientoForm(payload) {
    return {
        type: CHANGE_CORREGIMIENTO_FORM,
        payload
    };
}

export function openModalFormularioRegistro(payload) {
    return {
        type: OPEN_MODAL_FORMULARIO_REG,
        payload
    };
}

export function devueltaModificacionActive(payload) {
    return {
        type: DEVUELTA_MODIFICACION_ACTIVE,
        payload
    };
}

export function savedTamanioFiles(payload) {
    return {
        type: SAVED_TAMANIO_FILES,
        payload
    };
}

export function savedIdApp(payload) {
    return {
        type: SAVED_ID_APP,
        payload
    };
}

export function uploadAnexosSaga(payload) {
    return {
        type: UPLOAD_ANEXOS_FROM_SAGA,
        payload
    };
}

export function updateMsgSolicitud(payload) {
    return {
        type: UPDATE_MSG_SOLICITUD,
        payload
    };
}

export function saveUserComercial (payload) {
    return {
        type: SAVE_USER_COMERCIAL,
        payload
    }
}

export function chagesFromBandeja (payload) {
    return {
        type: CHANGES_FROM_BANDEJA,
        payload
    }
}

export function verMotivoDevolucion (payload) {
    return {
        type: VER_MOTIVO_DEVOLUCION,
        payload
    }
}

export function createUserPerson (payload) {
    return {
        type: CREATE_USUARIO_PERSONA,
        payload
    }
}

export function saveSolicitudesSinFirma (payload) {
    return {
        type: SAVE_SOLICITUDES_SIN_FIRMA,
        payload
    }
}

export function closeDireccionModalSuccess (payload) {
    return {
        type: CLOSE_DIRECCION_MODAL_SUCCESS,
        payload
    }
}
